export const isAdmin = () => (
  localStorage.getItem('didAdminComeIn') === 'true'
)
